import UpsertTagAttributeOptionsRequestItem from "@/api/Weeek/dataSource/api/project-manager/weeek/i-services/models/request/UpsertTagAttributeOptionsRequestItem";

export class WeeekOptionsUpsertTagsRequest {
  ProjectId!: number;
  Attributes!: Array<UpsertTagAttributeOptionsRequestItem>;
  constructor(obj?: Partial<WeeekOptionsUpsertTagsRequest>) {
    if (obj) {
      Object.assign(this, obj);
    }
  }
}
